<template>
<div class="pa-free-speech-widget">
    <div class="widget_slot loaded">
        <div class="rec-widget-header" style="background-color:#8b0000;">
            <div class="rec-title" style="color:#ffffff;">Free Speech</div>
        </div>
        <div class="free-speech-widget">
            <div class="is-mw-60 hero-text-content">
                <div class="mb-5">
                    <div class="logos is-relative">
                        <img src="https://speech.collegepulse.com/assets/cp.svg" alt="College Pulse" width="170" class="ml-4 logo-cp">
                            <img src="https://speech.collegepulse.com/assets/fire.svg" alt="Fire Organization" width="80" class="ml-6 logo-fire" style="margin-top: -2px;">
                            <img src="https://speech.collegepulse.com/assets/realclear.svg" class="ml-6 logo-real" width="150" alt="Real Clear Media Group" style="margin-top: 3px;">
                    </div>
                </div>
                <h1 class="title is-1 has-text-weight-bold">
                    <a class="" href="https://www.realcleareducation.com/speech/index.html">College Free Speech Rankings</a>
                </h1>
                <div class="divider mb-5" style="background-color: rgb(80, 227, 194); height: 2px;"></div>
                <p class="mt-3">The best and worst campuses for free speech, based on a survey of more than 37,000 students.</p>
                <div class="university-logos">
                    <ul>
                        <li>
                            <a class="" href="https://www.realcleareducation.com/speech/index.html">
                                <img src="/asset/img/universities/uchicago.png" alt="University of Chicago" />
                            </a>
                        </li>
                        <li>
                            <a class="" href="https://www.realcleareducation.com/speech/index.html">
                                <img src="/asset/img/universities/harvard.png" alt="Harvard University " />
                            </a>
                        </li>
                        <li>
                            <a class="" href="https://www.realcleareducation.com/speech/index.html">
                                <img src="/asset/img/universities/yale.png" alt="Yale Univiersity" />
                            </a>
                        </li>
                        <li>
                            <a class="" href="https://www.realcleareducation.com/speech/index.html">
                                <img src="/asset/img/universities/university-of-california-ucla-vector-logo.png" alt="University of california ucla" />
                            </a>
                        </li>
                        <li>
                            <a class="" href="https://www.realcleareducation.com/speech/index.html">
                                <img src="/asset/img/universities/university_texas.png" alt="University of Texas" />
                            </a>
                        </li>
                    </uL>
                </div>
                <div class="divider mb-5" style=" margin-bottom: 10px; background-color: rgb(80, 227, 194); height: 2px;"></div>
                <div>
                    <a class="button is-success" href="https://www.realcleareducation.com/speech/index.html">See the Rankings</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: 'free-speech-widget',
}
</script>